import Bold from '@tiptap/extension-bold'
import BubbleMenu from '@tiptap/extension-bubble-menu'
import Color from '@tiptap/extension-color'
import Document from '@tiptap/extension-document'
import HardBreak from '@tiptap/extension-hard-break'
import Italic from '@tiptap/extension-italic'
import Paragraph from '@tiptap/extension-paragraph'
import Strike from '@tiptap/extension-strike'
import Text from '@tiptap/extension-text'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'
import Underline from '@tiptap/extension-underline'
import { CustomLink } from './custom-link'
import History from '@tiptap/extension-history'
import TextDirection from 'tiptap-text-direction'
import { CustomOrderedList } from './custom-ordered-list'

export const baseExtensions = [
  Document,
  Paragraph,
  Text,
  Bold,
  Italic,
  Strike,
  Underline,
  Color,
  TextStyle,
  TextAlign,
  BubbleMenu,
  HardBreak,
  History,
  CustomOrderedList,
  CustomLink.configure({
    openOnClick: false,
    HTMLAttributes: {
      rel: null,
      target: null,
      style: 'cursor: pointer;',
      popupid: null,
    },
  }),
  TextDirection.configure({
    types: ['heading', 'paragraph', 'listItem'],
  }),
]
